module.exports = __webpack_public_path__ + "static/dmz-logo-a0324f2c92699b7dc3aee2ec16871e21.png";